import { trackingService } from '@monthio/react-components'
import React, { VoidFunctionComponent } from 'react'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components'

const StuckPageContainer = styled.div`
	display: flex;
	justify-content: center;
	flex-flow: column nowrap;
	width: 100%;
	padding: 50px 16px 0;
	box-sizing: border-box;
`

export const StuckPage: VoidFunctionComponent = () => {
	const { t, ready, i18n } = useTranslation()

	trackingService.trackTechnicalEvent('Stuck page reached')

	return (
		<StuckPageContainer>
			<p>{ready ? t('stuckPage-closeWindowHint') : null}</p>
			<p>
				{ready && i18n.language !== 'en-gb'
					? t('stuckPage-closeWindowHint', { lng: 'en-gb' })
					: null}
			</p>
		</StuckPageContainer>
	)
}
